export default "__VITE_ASSET__BDm9kbQs__"